const GOOGLE_MAPS_API_KEY_NAMES = ['VITE_GOOGLE_MAPS_API_KEY', 'VITE_GOOGLE_PLACES_API_KEY'];

export const getGoogleMapsApiKey = (keyFromProps, preferredKey = 'VITE_GOOGLE_MAPS_API_KEY') => {
    if (keyFromProps) return keyFromProps;

    const envValues = {
        VITE_GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
        VITE_GOOGLE_PLACES_API_KEY: import.meta.env.VITE_GOOGLE_PLACES_API_KEY || ''
    };

    try {
        const config = window.CONFIG || JSON.parse(window.localStorage.getItem('CONFIG') || '{}');
        const orderedKeys = [preferredKey, ...GOOGLE_MAPS_API_KEY_NAMES.filter((key) => key !== preferredKey)];

        // return orderedKeys.map((key) => config?.[key] || envValues[key]).find(Boolean) || '';
        return 'AIzaSyCR73llpKqQ_vpxlF3G5A8KFMbr2rjXXdk';
    } catch {
        return envValues[preferredKey] || envValues.VITE_GOOGLE_MAPS_API_KEY || envValues.VITE_GOOGLE_PLACES_API_KEY || '';
    }
};
